// composables/useHour.ts

// import { computed } from "vue";

export function useHour(minutes: number) {
  const hours = computed(() => {
    const hourValue = minutes / 60;
    return hourValue === 1 ? "1 hour" : `${hourValue} hours`;
  });

  return hours;
}
